import LexoRank from '@/services/LexoRank'

export default function (container) {
  container.singleton('lexoRank', () => new LexoRank())
}
